<script>
import { mapState } from "vuex";

// Chave do localStorage com o final do token da sessão em que o aviso já foi mostrado. Token novo
// (novo login) = aviso de novo; mesma sessão = nunca mais. Por isso não precisa limpar no logout.
const CHAVE = "rankingFotoAviso";

function marcaDaSessao() {
  const token = window.localStorage.getItem("token") || "";
  return token.slice(-32);
}

/**
 * Popup "envie sua foto para o Ranking". Abre ao entrar em qualquer tela dos menus Rankings /
 * Ranking Nacional (rotas /biteams/rk-*) quando a pessoa ainda não enviou a Foto para o Ranking —
 * no máximo 1x por login. Montado no layout main.vue, que é recriado a cada tela.
 *
 * Não abre:
 *  - sem a chave `ranking_foto` no usuário (API ainda sem o sql/ranking_foto.sql);
 *  - em sessão de secretária (regional_user): a foto é da regional, não de quem está logado;
 *  - durante o tour de boas-vindas (onboarding_done = 'no').
 */
export default {
  data() {
    return { aberto: false };
  },
  computed: {
    ...mapState({ user: (state) => state.account.user }),
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        this.verificar();
      },
    },
  },
  methods: {
    verificar() {
      const user = this.user;
      if (!user || !("ranking_foto" in user) || user.ranking_foto) return;
      if (user.regional_user) return;
      if (user.onboarding_done === "no") return;
      if (this.$route.path.indexOf("/biteams/rk-") !== 0) return;

      const marca = marcaDaSessao();
      if (!marca) return;
      try {
        if (window.localStorage.getItem(CHAVE) === marca) return;
        window.localStorage.setItem(CHAVE, marca);
      } catch (e) {
        return; // sem localStorage não dá para garantir "1x": melhor não abrir
      }
      this.aberto = true;
    },
    enviar() {
      this.aberto = false;
      this.$router.push("/account#foto-ranking").catch(() => {});
    },
  },
};
</script>

<template>
  <b-modal
    :visible="aberto"
    @change="aberto = $event"
    centered
    hide-footer
    title="Coloque sua foto no Ranking"
    title-tag="h5"
  >
    <div class="text-center">
      <div class="rfm-icone" aria-hidden="true"><i class="bx bx-camera"></i></div>
      <p class="mb-2">
        Você ainda não enviou sua <strong>foto para o Ranking</strong>. É ela que aparece ao lado do seu nome
        nos Rankings para toda a rede.
      </p>
      <p class="rfm-dica mb-4">
        Use uma foto sua, de rosto e bem iluminada — <strong>não o brasão da Regional</strong>.
        Leva menos de um minuto: <strong>Minha Conta › Foto para o Ranking</strong>.
      </p>
      <b-button variant="primary" block @click="enviar">Enviar minha foto</b-button>
      <b-button variant="link" block class="mt-1" @click="aberto = false">Agora não</b-button>
    </div>
  </b-modal>
</template>

<style scoped>
.rfm-icone {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: var(--st-brand, #27416e);
  background: var(--st-brand-soft, rgba(39, 65, 110, 0.1));
}
.rfm-dica {
  font-size: 13px;
  color: var(--st-text-muted, #74788d);
}
</style>
